import type { Meme } from '@/types';

export const memes: Meme[] = [
  {
    id: 'altushki',
    title: 'Альтушки',
    description: 'Ну, вы знаете их',
  },
  {
    id: 'cpp-tactics',
    title: 'C++ Спецтактика',
    description: 'Продвинутые тактики работы с C++ на грани возможного',
  },
  {
    id: 'boss-of-gym',
    title: "Boss of this Gym",
    description: 'Высшая ступень иерархии в спортивном зале. Требует 300 баксов за вход.',
  },
  {
    id: 'deep-dark-fantasies',
    title: 'Deep Dark Fantasies',
    description: 'То, что происходит в раздевалке, остается в базе данных.',
  },
  {
    id: 'dungeon-master',
    title: 'Dungeon Master',
    description: 'Тот, кто управляет всеми пайплайнами и деплоями.',
  },
  {
    id: 'ass-we-can',
    title: 'Ass we can',
    description: 'Девиз оптимизации градиентного спуска.',
  },
  {
    id: 'kek',
    title: 'Кек',
    description: 'Постироничное выражение веселья и одобрения',
  },
];
